function SkateDice() {
  return (
    <div className="dice-face face--sk8dice">
      <span>SK8</span>
      <span>DICE</span>
    </div>
  );
}

export default SkateDice;
